module.exports = __webpack_public_path__ + "img/symbol_9.03a7ec57.png";